'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _components = require('components');

var _reactSticky = require('react-sticky');

var _reactCopyToClipboard = require('react-copy-to-clipboard');

var _reactCopyToClipboard2 = _interopRequireDefault(_reactCopyToClipboard);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _reactKeydown = require('react-keydown');

var _reactKeydown2 = _interopRequireDefault(_reactKeydown);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _Outfeat = require('./Outfeat.scss');

var _Outfeat2 = _interopRequireDefault(_Outfeat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var currencies = [{
  val: 1.140265,
  alias: ["€", "eur", "euro", "euros"]
}, {
  val: 1.424005,
  alias: ["£", "pound", "livre", "livre sterling", "gbp"]
}];

var Outfeat = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    isLoading: state.outfeat.isLoading,
    outfeat: state.entities.outfeats[state.outfeat.display],
    error: state.outfeat.display.error,
    discover: state.discover.outfeats,
    fromPage: state.outfeatNavigation.fromPage
  };
}), _dec2 = (0, _reactKeydown2.default)(39), _dec3 = (0, _reactKeydown2.default)(37), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(Outfeat, _Component);

  function Outfeat(props) {
    (0, _classCallCheck3.default)(this, Outfeat);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(Outfeat).call(this, props));

    _this2.state = {
      openModalShare: false,
      created: false,
      copied: false
    };

    _this2.renderError = _this2.renderError.bind(_this2);
    _this2._next = _this2._next.bind(_this2);
    _this2._previous = _this2._previous.bind(_this2);

    return _this2;
  }

  (0, _createClass3.default)(Outfeat, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.context.location.query.created) {
        this.setState({ openModalShare: true, created: true });
      }
    }
  }, {
    key: 'renderError',
    value: function renderError() {
      return _react2.default.createElement(
        'div',
        { className: _Outfeat2.default.empty },
        _react2.default.createElement(
          'h1',
          null,
          'Oh no.'
        ),
        _react2.default.createElement(
          'p',
          null,
          "The outfeat you are looking for doesn't exist."
        )
      );
    }
  }, {
    key: 'getPriceInfo',
    value: function getPriceInfo() {
      var outfeat = this.props.outfeat;

      var outfitPrice = 0;
      var parsedItemsCount = 0;
      if (outfeat && outfeat.items) {
        outfeat.items.forEach(function (item) {
          if (item.price) {
            var nums = item.price.match(/\d+/);
            if (nums) {
              (function () {
                parsedItemsCount++;
                var price = {
                  num: parseInt(nums[0]),
                  cur: item.price.replace(/[0-9]/g, '').trim().toLowerCase()
                };
                var filter = currencies.filter(function (currency) {
                  var found = false;
                  currency.alias.forEach(function (name) {
                    if (price.cur.includes(name)) {
                      found = true;
                    }
                  });
                  return found;
                });
                if (filter.length > 0) {
                  outfitPrice += price.num * filter[0].val;
                } else {
                  // Assumes dollar
                  outfitPrice += price.num;
                }
              })();
            }
          }
        });
        outfitPrice = Math.round(outfitPrice);
      }
      return { outfitPrice: outfitPrice, parsedItemsCount: parsedItemsCount };
    }
  }, {
    key: '_next',
    value: function _next() {
      var nextOutfeatId = this.outfeatList[this.outfeatList.length > this.idx + 1 ? this.idx + 1 : 0];
      this.context.router.push('/' + nextOutfeatId);
    }
  }, {
    key: '_previous',
    value: function _previous() {
      var nextOutfeatId = this.outfeatList[this.idx === 0 ? this.outfeatList.length - 1 : this.idx - 1];
      this.context.router.push('/' + nextOutfeatId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props;
      var outfeat = _props.outfeat;
      var isLoading = _props.isLoading;
      var error = _props.error;
      var fromPage = _props.fromPage;
      var discover = _props.discover;


      this.outfeatList = fromPage === 'discover' || fromPage == null ? discover : []; // to be replaced with user outfeats list
      if (!outfeat) {
        return _react2.default.createElement('div', null);
      }
      this.idx = this.outfeatList.findIndex(function (outfeatId) {
        return outfeatId === outfeat.id;
      });

      var username = '';
      if (outfeat && outfeat.user && outfeat.user.username) {
        username = outfeat.user.username;
      }
      if (!!error) {
        return this.renderError();
      } else if (!outfeat) {
        return _react2.default.createElement('div', null);
      }

      var priceInfo = this.getPriceInfo();
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, { title: 'Outfeat' }),
        _react2.default.createElement(
          _reactSticky.StickyContainer,
          null,
          _react2.default.createElement(
            'div',
            { className: _Outfeat2.default.mainContainer },
            _react2.default.createElement(
              'section',
              { className: (0, _classnames2.default)(_Outfeat2.default.section, _Outfeat2.default.slider) },
              _react2.default.createElement(_components.ImageSlider, {
                pics: outfeat.images
              })
            ),
            _react2.default.createElement(
              'section',
              { className: (0, _classnames2.default)(_Outfeat2.default.itemList) },
              _react2.default.createElement(
                'div',
                { className: _Outfeat2.default.content },
                outfeat.items && _react2.default.createElement(_components.ItemList, { isLoading: isLoading, items: outfeat.items })
              )
            ),
            _react2.default.createElement(
              _reactSticky.Sticky,
              { style: { zIndex: 100 } },
              _react2.default.createElement(
                'div',
                { className: _Outfeat2.default.header },
                _react2.default.createElement(
                  'div',
                  { className: _Outfeat2.default.navigate },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('i', { className: 'ion-android-close' })
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('i', { className: 'ion-android-arrow-back', onClick: function onClick() {
                        return _this3._previous();
                      } })
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('i', { className: 'ion-android-arrow-forward', onClick: function onClick() {
                        return _this3._next();
                      } })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: _Outfeat2.default.stats },
                  _react2.default.createElement(
                    'div',
                    { className: _Outfeat2.default.stat },
                    _react2.default.createElement(
                      'b',
                      null,
                      '$' + priceInfo.outfitPrice
                    ),
                    _react2.default.createElement(
                      'small',
                      null,
                      priceInfo.parsedItemsCount + ' items'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _Outfeat2.default.stat },
                    _react2.default.createElement(
                      'b',
                      null,
                      outfeat.view_count
                    ),
                    _react2.default.createElement(
                      'small',
                      null,
                      'Views'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _Outfeat2.default.profilePicContainer },
                    outfeat.user && outfeat.user.id && _react2.default.createElement(_reactRouter.Link, { to: "/@" + outfeat.user.username, 'data-tip': outfeat.user.username, className: _Outfeat2.default.profilePic, style: { backgroundImage: 'url(' + outfeat.user.profile_picture + ')' } }),
                    !outfeat.user && _react2.default.createElement(
                      'div',
                      { 'data-tip': 'Anonymous', className: (0, _classnames2.default)(_Outfeat2.default.profilePic, _Outfeat2.default.anonymous) },
                      ' ',
                      _react2.default.createElement('i', { className: 'ion-android-person' }),
                      ' '
                    ),
                    _react2.default.createElement(_reactTooltip2.default, null)
                  )
                )
              )
            )
          )
        ),
        this.state.openModalShare && _react2.default.createElement(
          _components.Modal,
          { onClose: function onClose() {
              return _this3.setState({ openModalShare: false });
            } },
          _react2.default.createElement(
            'div',
            { className: _Outfeat2.default.modalContent },
            _react2.default.createElement(
              'h2',
              null,
              'Share your style.'
            ),
            _react2.default.createElement(
              'p',
              { className: _Outfeat2.default.description },
              'Copy & paste the link below to share your outfeat:'
            ),
            _react2.default.createElement(
              _reactCopyToClipboard2.default,
              {
                onCopy: function onCopy() {
                  _this3.setState({ copied: true });
                  var _this = _this3;
                  setTimeout(function () {
                    _this.setState({ copied: false });
                  }, 5000);
                },
                text: 'http://outfeats.com/' + outfeat.id },
              _react2.default.createElement(
                'span',
                { className: (0, _classnames2.default)(_Outfeat2.default.copy, (0, _defineProperty3.default)({}, _Outfeat2.default.active, this.state.copied)) },
                'http://outfeats.com/',
                outfeat.id
              )
            )
          )
        )
      );
    }
  }]);
  return Outfeat;
}(_react.Component), _class3.propTypes = {
  outfeat: _react.PropTypes.object
}, _class3.contextTypes = {
  location: _react2.default.PropTypes.object,
  history: _react2.default.PropTypes.object,
  router: _react2.default.PropTypes.object,
  routing: _react2.default.PropTypes.object
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, '_next', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, '_next'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, '_previous', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, '_previous'), _class2.prototype)), _class2)) || _class);
exports.default = Outfeat;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Outfeat/Outfeat.js
 ** module id = 1113
 ** module chunks = 0
 **/